import solver from 'javascript-lp-solver';

import calculateWaterAvailable from './getWaterAvailable';
import getLookupValues from './getLookupValues';
import getScenarioName from './getScenarioName';

export default function runOptimizeScenario(language, values, scenario) {
  const lookupValues = getLookupValues(
    values.crops,
    values.weatherStation,
    values.soilCode,
    values.landAvailableUnit,
    language
  );

  let landAvailable = parseFloat(values.landAvailable);
  let waterAvailable = calculateWaterAvailable(values);

  let cropVariables = {};
  let boundConstraints = {};

  values.crops.forEach((crop, cropIndex) => {
    const cropYield = crop.typicalYield;
    const cropWaterNeeds = lookupValues[crop.name].monthlyWater * 1000; // convert from m3 to liters
    const cropProfit = crop.marketPrice * cropYield - crop.costToPlant;

    values.crops[cropIndex]['profit'] = cropProfit;
    values.crops[cropIndex]['waterNeeds'] = cropWaterNeeds;

    if (scenario === 3) {
      boundConstraints[`x${cropIndex}`] = {
        max: landAvailable,
      };
    } else if (scenario === 4) {
      boundConstraints[`x${cropIndex}`] = {
        max: landAvailable / values.crops.length,
      };
    } else {
      boundConstraints[`x${cropIndex}`] = {
        max: landAvailable * (values.crops[cropIndex]['bound'] * 0.01),
      };
    }

    let boundVariables = {};
    for (let boundIndex = 0; boundIndex < values.crops.length; boundIndex++) {
      if (cropIndex === boundIndex) {
        boundVariables[`x${boundIndex}`] = 1;
      } else {
        boundVariables[`x${boundIndex}`] = 0;
      }
    }

    cropVariables[crop.name] = {
      profit: -1 * cropProfit,
      landAvailable: 1,
      waterAvailable: cropWaterNeeds,
      ...boundVariables,
    };
  });

  const model = {
    optimize: 'profit',
    optType: 'max',
    constraints: {
      landAvailable: { max: landAvailable },
      waterAvailable: { max: waterAvailable },
      ...boundConstraints,
    },
    variables: {
      ...cropVariables,
    },
  };

  const results = solver.Solve(model);

  let cropMix = [];
  let profits = [];
  let waterUse = [];
  let irrigationRequiredTime = [];

  values.crops.forEach((crop) => {
    if (results.hasOwnProperty(crop.name)) {
      cropMix.push([
        {
          x: getScenarioName(scenario, language),
          y: results[crop.name],
          name: crop.name,
        },
      ]);
      profits.push([
        {
          x: getScenarioName(scenario, language),
          y: (results[crop.name] * crop.profit) / 1000,
          name: crop.name,
        },
      ]);
      waterUse.push([
        {
          x: getScenarioName(scenario, language),
          y: Math.round((results[crop.name] * crop.waterNeeds) / 1000),
          name: crop.name,
        },
      ]);
      irrigationRequiredTime.push([
        {
          x: getScenarioName(scenario, language),
          y:
            (results[crop.name] * crop.waterNeeds) /
            (parseFloat(values.waterAccessFlowRate) * 3600),
          name: crop.name,
        },
      ]);
    }
  });

  return { cropMix, profits, waterUse, irrigationRequiredTime };
}
